import { parseEntityItemId, QUESTION_IMAGE_IDENTIFIER } from '@wix/a11y-rules';
import { updateForm } from '@wix/ambassador-forms-v4-form/http';
import { assertNotOptional } from '@wix/seo-common-core';
import { groupBy } from 'lodash';
export const updateOnlineProgramsQuizzesImages = async (httpClient, errorHandler, altTextData, quizzesData) => {
  const {
    withErrorHandler
  } = errorHandler;
  if (!quizzesData || !quizzesData.imageToQuizMap || !quizzesData.quizzes) {
    return {
      success: false
    };
  }
  const updatesByFormId = getUpdatedAltTextByQuizId(altTextData);
  const promiseArray = Object.values(updatesByFormId).map(value => {
    const updateRequest = getUpdateRequest(value, quizzesData);
    return withErrorHandler(async () => {
      httpClient.request(updateForm(updateRequest));
    }, {
      errorCodesMap: {}
    });
  });
  const results = await Promise.allSettled(promiseArray);
  const isFailed = results.some(result => result.status === 'rejected');
  const allFailedElements = isFailed ? altTextData : [];
  return {
    failedElements: allFailedElements,
    success: !isFailed
  };
};
const getUpdatedAltTextByQuizId = altTextData => {
  const data = altTextData.map(alt => {
    const {
      entities,
      itemId
    } = parseEntityItemId(alt.id, 1);
    const splitArr = itemId.split('#');
    const questionIndex = splitArr[splitArr.length - 2];
    const imageType = splitArr[splitArr.length - 1];
    const [formId] = entities;
    return {
      ...alt,
      formId,
      imageType,
      questionIndex
    };
  });
  return groupBy(data, _ref => {
    let {
      formId
    } = _ref;
    return formId;
  });
};
const getUpdateRequest = (altToUpdate, quizzesData) => {
  const originalForm = quizzesData.quizzes.find(quiz => quiz.id === altToUpdate[0].formId);
  assertNotOptional(originalForm);
  const updatedForm = {
    ...originalForm
  };
  altToUpdate.forEach(alt => {
    const questionIndex = Number(alt.questionIndex);
    if (alt.imageType === QUESTION_IMAGE_IDENTIFIER) {
      updatedForm.fields[questionIndex].view.questionImageAltText = alt.alt;
    } else {
      const optionIndex = Number(alt.imageType);
      const option = updatedForm.fields[questionIndex].view.options[optionIndex];
      updatedForm.fields[questionIndex].view.options[optionIndex] = {
        ...option,
        altText: alt.alt
      };
    }
  });
  return {
    form: updatedForm
  };
};
//# sourceMappingURL=update-online-programs-forms-images.js.map